// extracted by mini-css-extract-plugin
module.exports = {"root":"SnoozeBody_root__EL618"};